import { Model } from './model';

export class CampaignList extends Model {
  idCampaign: string;
  title: string;
}
